<div class="container" style="max-width:1024px!important;margin:0px;padding:0px">
  <div class="row" style="bottom:0;margin:0px 25px 5px 5px;padding: 10px 0px;">
    <div class="col-lg-12" style="padding:0px;">
      <div style="display:inline-block;width: 100%;">
        <!--<table style="width: 100%;">
    <tr>
      <td></td>
      <td>
      </td>
    </tr>
  </table>-->
        <div class="menu-icon" routerLink="" (click)="active = 1" style="width:3%;vertical-align: top;">
          <img src="assets/images/home.png" class="home-icon" />
        </div>
        <div style="display: inline-block;width:97%;padding-left: 5px;">
          <div [ngClass]="{'menu-item':true, 'active': active == 2}" (click)="active = 2" routerLink="/page/intro" routerLinkActive="active">Introduction</div>
          <div [ngClass]="{'menu-item':true, 'active': active == 3}" (click)="active = 3" routerLink="/page/panadol" routerLinkActive="active">Panadol</div>
          <div [ngClass]="{'menu-item':true, 'active': active == 4}" (click)="active = 4" routerLink="/page/panadol-extra" routerLinkActive="active">Panadol Extra</div>
          <div [ngClass]="{'menu-item':true, 'active': active == 5}" (click)="active = 5" routerLink="/page/panadol-kids" routerLinkActive="active">Panadol Kids</div>
          <div [ngClass]="{'menu-item':true, 'active': active == 6}" (click)="active = 6" routerLink="/page/suitability" routerLinkActive="active">Suitability</div>
          <div [ngClass]="{'menu-item':true, 'active': active == 7}" (click)="active = 7" routerLink="/page/guidelines" routerLinkActive="active">Guidelines</div>
          <div [ngClass]="{'menu-item':true, 'active': active == 8}" (click)="active = 8" routerLink="/page/reference" routerLinkActive="active">References</div>
        </div>
      </div>
      <!-- <div style="display:inline-block;float:right;" class="d-none d-md-block">
        <div class="menu-icon"><img src="assets/images/arrow-left.png" class="home-icon" /></div>
        <div class="menu-item-txt">0{{active}} / 10</div>
        <div class="menu-icon"><img src="assets/images/arrow-right.png" class="home-icon" /></div>
      </div> -->
    </div>
  </div>
</div>
